import React from "react";
import { ProvideDetailsComponent } from "../Componentns/ProvideDetailsComponent";

const ProvideDetails = () => {
    return(
        <ProvideDetailsComponent />
    );
}

export default ProvideDetails;